import { useRef, useEffect } from 'react'; // Add this import
import { menuDotsVerticalSVG } from '../../lib/allCustomSVGs';
import '../../styles/components/subPageList/subPageList.scss';
import CustomSVGs from '../../ui/customSVGs/CustomSVGs';
import SubPageListDropdown from '../dropdowns/SubPageListDropdown';
import { useNavigate } from 'react-router-dom';

interface Props {
  mainTitle?: string;
  subTitle?: string;
  onListMenuClick?: (e: any) => void;
  onListItemClick?: () => void;
  isListMenuOpen?: any;
  items: any;
  viewItemURL?: string;
  dropdownItems?: {
    id: string;
    icon: any;
    title: string;
    subTitle: string;
    url: string;
  }[];
}

const SubPageList = ({
  mainTitle,
  subTitle,
  items,
  dropdownItems,
  onListMenuClick,
  isListMenuOpen,
  onListItemClick,
  viewItemURL,
}: Props) => {
  // Create refs to track menu buttons and dropdowns
  const menuButtonRefs = useRef<{ [key: string]: HTMLElement | null }>({});
  const dropdownRefs = useRef<{ [key: string]: HTMLElement | null }>({});
  const navigate = useNavigate();
  // Handle clicks outside the dropdown
  useEffect(() => {
    if (!isListMenuOpen) return; // Exit if no dropdown is open
    const handleClickOutside = (event: MouseEvent) => {
      Object.keys(isListMenuOpen).forEach((id) => {
        if (isListMenuOpen[id]) {
          const menuButton = menuButtonRefs.current[id];
          const dropdown = dropdownRefs.current[id];
          const target = event.target as Node;

          if (
            menuButton &&
            !menuButton.contains(target) &&
            dropdown &&
            !dropdown.contains(target)
          ) {
            onListMenuClick && onListMenuClick(id); // Close the dropdown
          }
        }
      });
    };

    const isAnyOpen = Object.values(isListMenuOpen).some((val) => val);
    if (isAnyOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isListMenuOpen, onListMenuClick]);

  return (
    <div className='subPageList'>
      <div className='subPageList__top'>
        <h1>{mainTitle}</h1>
        <span>{subTitle}</span>
      </div>
      <ul className='subPageList__bottom'>
        {items?.map((item: any, i: number) => {
          return (
            <li key={i} className='subPageList__bottom--item'>
              <div
                title={viewItemURL ? 'Click to view details' : ''}
                onClick={() => {
                  if (viewItemURL) {
                    navigate(`${viewItemURL}/${item?.id}`);
                  }
                }}
                className='subPageList__bottom--item-left'
              >
                {item?.img && (
                  <div className='subPageList__bottom--item-left-img'>
                    <img src={item?.img} alt={item?.title} />
                  </div>
                )}
                <div className='subPageList__bottom--item-left-titles'>
                  <h3>{item?.title}</h3>
                  <p>{item?.subTitle}</p>
                  {item?.sKey && (
                    <span>{`${item?.sKey?.slice(0, 4)}**********`}</span>
                  )}
                </div>
              </div>
              <div className='subPageList__bottom--item-right'>
                {onListItemClick && dropdownItems && isListMenuOpen[item?.id] && (
                  <div ref={(el) => (dropdownRefs.current[item.id] = el)}>
                    <SubPageListDropdown
                      id={item?.id}
                      dropdownItems={dropdownItems}
                      onListItemClick={onListItemClick}
                    />
                  </div>
                )}
                {onListMenuClick ? (
                  <div
                    className='subPageList__bottom--item-right-svg'
                    ref={(el) => (menuButtonRefs.current[item.id] = el)}
                    onClick={() => onListMenuClick(item?.id)}
                  >
                    <CustomSVGs svg={menuDotsVerticalSVG} />
                  </div>
                ) : null}

                {item?.status && (
                  <span
                    className='subPageList__bottom--item-right-status'
                    style={{
                      color: item?.status === 'active' ? '#4CAF50' : '#F44336',
                    }}
                  >
                    {item?.status}
                  </span>
                )}
              </div>
            </li>
          );
        })}
      </ul>
    </div>
  );
};

export default SubPageList;
